module.exports = __webpack_public_path__ + "static/media/default-food-type.145f7536.svg";